import PazienteWincareOld from "../";

const routes = [{ name: "PazienteEventiList", path: "/paziente/wincareoldeventilista", component: PazienteWincareOld.PazienteWincareOldEventiList, meta: { title: "" } }];

export default routes;
